<div class="tap-and-drop">
    <div class="question question-{{id}} {{class}}">
        <div class="question-text"><div class="text">{{{t text}}}</div></div>
        {{#if blocks}}<div data-region="question-blocks" class="question-blocks"></div>{{/if}}
        <div class="answers-container" data-answer-count="{{answers.length}}">
            <div class="question-answers">
                {{#each answers}}
                    <div answerId={{id}} class="question-answer answer-{{id}}">
                        <div class="answer-text">{{{t text}}}</div>
                    </div>
                {{/each}}
            </div>
            <div class="question-answer-containers">
                {{#if sequential}}
                    {{#each answers}}
                        <div containerId={{@index}} class="question-answer-container">
                            <div class="answer-text"></div>
                        </div>
                    {{/each}}
                {{else}}
                    <div containerId=0 class="question-answer-container">
                        <div class="answer-text"></div>
                    </div>
                {{/if}}
            </div>
        </div>
        <div id="tap-and-drop-submit-button" class="tap-and-drop-submit-button">{{{t button_text}}}</div>
    </div>
</div>